// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".manual .title[data-v-0d58f118] {\n  font-size: 14px;\n  text-indent: 2em;\n  padding: 6px 0;\n  margin: 0;\n  line-height: 18px;\n}", ""]);
// Exports
module.exports = exports;
